/* Which trailer the customer is shopping for. One answer, for everybody.

   THIS EXISTS BECAUSE THE ANSWER WAS IN THREE PLACES AND TWO OF THEM WERE
   EMPTY ON A PRODUCT PAGE. The extension writes trailerData while the search
   surfaces are on screen, so anything reading only that key computed "no
   trailer on file" on every product page, silently, while the app block a few
   hundred pixels away was correctly saying the part fits. Nothing errored.
   That is the worst kind of wrong.

   The order is deliberate:

   1. trailerData, the extension's live record, when it is there. It is the
      most current and it is what the extension itself acts on.
   2. lastSearchedTrailer, the extension's own persisted copy. This is what
      the product page app block reads, so following it second means our
      surfaces and the app block cannot disagree.
   3. fxTrailerLog[0], our drawer's history, newest first. fx-recall.js only
      writes a row once the customer has made a real gesture, so a default
      filter never gets in here.

   fxTrailerPick is NOT in that list. It is the state of three select elements
   and it holds a value whether anybody chose it or not. */
(function () {
  'use strict';

  function read(k) {
    try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; }
  }

  function clean(s) { return String(s == null ? '' : s).trim(); }

  window.fxTrailer = function () {
    var live = read('trailerData');
    if (live && live.modelName) {
      var pick = read('fxTrailerPick');
      return {
        model: clean(live.displayModelName || live.modelName),
        year: clean(live.vinModelYear || (pick && pick.modelYear)),
        vin: clean(live.vinNumber),
        from: 'live'
      };
    }

    var last = read('lastSearchedTrailer');
    if (last && last.modelName) {
      return {
        model: clean(last.productTitle || last.modelName),
        year: clean(last.modelYear),
        vin: clean(last.vinNumber),
        from: 'last'
      };
    }

    var log = read('fxTrailerLog');
    var top = log && log.length ? log[0] : null;
    if (top && top.model) {
      return {
        model: clean(top.model),
        year: clean(top.year),
        vin: top.kind === 'vin' ? clean(top.vin) : '',
        from: 'log'
      };
    }

    return null;
  };
})();
